export function PortalBrandHeader({ label }: { label: string }) {
  return (
    <div style={{ backgroundColor: '#0d1f3c' }}>
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between gap-3">
        {/* R5 (2026-08-24): the hardcoded gold "Y" mark was removed here — it
            rendered on every client's portal regardless of firm. Logo /
            visual identity is a deferred paid feature (white-labelling),
            not something to substitute with the platform's own mark. */}
        <span
          className="truncate"
          style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.04em', color: 'rgba(255,255,255,0.7)' }}
        >
          {label}
        </span>
      </div>
      <div style={{ height: '2px', backgroundColor: '#c9a227' }} />
    </div>
  )
}
